var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39539 7.38205L0.26665 1.78619C-0.338618 1.12779 0.153296 0.0937504 1.07189 0.0937504H11.3294C11.535 0.0935821 11.7362 0.149982 11.9091 0.256196C12.082 0.362411 12.2191 0.513937 12.3041 0.692629C12.389 0.871321 12.4182 1.0696 12.3882 1.26373C12.3581 1.45786 12.2701 1.63961 12.1346 1.78721L7.00587 7.38103C6.9055 7.49067 6.78172 7.57855 6.64283 7.63875C6.50394 7.69896 6.35317 7.73011 6.20063 7.73011C6.04809 7.73011 5.89732 7.69896 5.75843 7.63875C5.61955 7.57855 5.49576 7.49067 5.39539 7.38103V7.38205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.7c5602f1d4256d389384fe641ce0693c.svg";
export { ForwardRef as ReactComponent };